var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 20,
    fill: "url(#paint0_linear_193_346)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20.5996L41.5 26.0996V37.0996L32 42.5996L22.5 37.0996V26.0996L32 20.5996ZM32 22.9196L24.5 27.2596V35.9396L32 40.2796L39.5 35.9396V27.2596L32 22.9196ZM32 35.5996C31.28 35.5996 30.6133 35.4196 30 35.0596C29.3867 34.6996 28.9 34.2129 28.54 33.5996C28.18 32.9863 28 32.3196 28 31.5996C28 30.8796 28.18 30.2129 28.54 29.5996C28.9 28.9863 29.3867 28.4996 30 28.1396C30.6133 27.7796 31.28 27.5996 32 27.5996C32.72 27.5996 33.3867 27.7796 34 28.1396C34.6133 28.4996 35.1 28.9863 35.46 29.5996C35.82 30.2129 36 30.8796 36 31.5996C36 32.3196 35.82 32.9863 35.46 33.5996C35.1 34.2129 34.6133 34.6996 34 35.0596C33.3867 35.4196 32.72 35.5996 32 35.5996ZM32 33.5996C32.36 33.5996 32.6933 33.5096 33 33.3296C33.3067 33.1496 33.55 32.9063 33.73 32.5996C33.91 32.2929 34 31.9596 34 31.5996C34 31.2396 33.91 30.9063 33.73 30.5996C33.55 30.2929 33.3067 30.0496 33 29.8696C32.6933 29.6896 32.36 29.5996 32 29.5996C31.64 29.5996 31.3067 29.6896 31 29.8696C30.6933 30.0496 30.45 30.2929 30.27 30.5996C30.09 30.9063 30 31.2396 30 31.5996C30 31.9596 30.09 32.2929 30.27 32.5996C30.45 32.9063 30.6933 33.1496 31 33.3296C31.3067 33.5096 31.64 33.5996 32 33.5996Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_346",
    x1: 0,
    y1: 0,
    x2: 64,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground4);
export default __webpack_public_path__ + "static/media/Background-4.90fc04134211de20b3bca9b6cd76df10.svg";
export { ForwardRef as ReactComponent };